
























































































































import { Component, Prop } from 'vue-property-decorator';
import { QuestionnaireGatewayCpt } from '.';
import _ from 'lodash';

import AppVue from '@/AppVue.vue';
import { QuestionnaireLookups, QuestionnaireModel } from '@/core/models';
import { InputNumberCpt, MultiInputSumCpt, InputRadioCpt } from '@/core/components';
import { Gateway } from '@/core/constants';

@Component({
  components: {
    QuestionnaireGatewayCpt,
    InputRadioCpt,
    MultiInputSumCpt,
    InputNumberCpt,
  },
})
export default class QuestionnaireGatewayWorkshop1Cpt extends AppVue {
  @Prop() lookups: QuestionnaireLookups;
  @Prop() model: QuestionnaireModel;
  @Prop({ default: false }) disabled: boolean;

  get gateway() {
    return Gateway;
  }

  created() {
    // this.loadModel();
  }
}
